<template>
    <div id="targetDataComponent">
        <div id="targetTableDiv">
            <b-table hover :items="listData" :fields="fields" 
            :responsive="false" 
            small 
            selectable select-mode="multi"
            @row-selected="onRowSelected" 
            id="targetData">
                <template v-slot:cell(id)="data">
                    <p class="mb-2 targetDataP">
                        <b-icon scale="1.2" icon="arrow-left" v-if="data.item.type === 'route'"></b-icon>
                        <b-icon scale="1.2" icon="truck" v-if="data.item.type === 'vehicle'"></b-icon>
                        <span style="padding-left:0.5em;padding-right:0.5em;">{{ data.item.id }}</span>
                        :
                        <span style="padding-left:0.5em;padding-right:0.5em;"><b>{{ data.item.label }}</b></span>
                    </p>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DocumentTargetList',
    props: {
        targetdata: Array
    },
    data() {
        return {
            fields: [
                { key: 'id', label: this.$t('document_targets.attachments_title'), sortable: true }
            ],
            currentPage: 1,
            selected: [],
            listData: [],
            listLength: 0,
            pagingPerPage: 10,
            filter: null,
            filterOn: ['id', 'label'],
            creatingNew: false
        };
    },
    created() {
        this.listData = this.targetdata || [];
    },
    watch: {
        targetdata() {
            if (!this.creatingNew) {
                this.listData = this.targetdata || [];
            }
        }
    },
    methods: {
        emptyList() {
            this.listData = [];
            this.listLength = 0;
            this.currentPage = 1;
        },
        onRowSelected(items) {
            this.selected = items;
        },
        removeSelectedTargets() {
            this.listData = this.listData.filter(item => !this.selected.includes(item));
        },
        addTargets(list) {
            list.forEach(item => {
                if (!this.targetDataContains(item, this.listData)) {
                    this.listData.push(item);
                }
            });
        },
        getTargetListData() {
            return {
                routeTargets: this.listData
                    .filter(item => item.type === 'route')
                    .map(item => ({ id: item.id, label: item.label })),
                vehicleTargets: this.listData
                    .filter(item => item.type === 'vehicle')
                    .map(item => ({ id: item.id, label: item.label }))
            };
        },
        targetDataContains(item, list) {
            return list.some(listItem => listItem.id === item.id && listItem.type === item.type);
        }
    }
}
</script>

<style scoped lang="scss">
#targetData {
    height: 9em;
}

#targetTableDiv {
    height: 20em;
    overflow: auto;
}

.targetDataP {
    margin-top: -10px;
    margin-bottom: -10px !important;
}
</style>
